import { render, staticRenderFns } from "./LSidebar2.vue?vue&type=template&id=56990f4c&"
import script from "./LSidebar2.vue?vue&type=script&lang=js&"
export * from "./LSidebar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports